/*
自动化无埋点方式计算页面FCP/FMP/TTI时间

根据需要设置页面 TTI 超时时间阈值
// 需要在引入组件前设置，默认值为 10000（10秒）
window.TTI_LIMIT = 10000;
*/
import FT from './kewlfmptti-source.js'

try {
    FT.then(({ fcp, fmp, tti }) => {
        console.log('首次内容绘制（FCP） - %dms', fcp);
        console.log('首次有意义绘制（FMP） - %dms', fmp);
        console.log('可交互时间（TTI） - %dms', tti);
        if (window.KEWLSensor && window.KEWLSensor.register && window.KEWLSensor.track) {
            let params = {
                ft_fcp: fcp,
                ft_fmp: fmp,
                ft_tti: tti
            };
            // 神策埋点
            window.KEWLSensor.register('kewlweb_fmp_tti_stats', params);
            window.KEWLSensor.track(params);
        } else {
            console.log('kewl-fmp-tti-not-sensors');
        };
    });
} catch (err) {
    console.log('kewl-fmp-tti', err);
};